import PropTypes from 'prop-types'
import FinancePaymentsUrlParamsTableCellService from './finance-payments-url-params-table-cell-service.js'

const propTypes = {
  payment              : PropTypes.object,
  onClickRow               : PropTypes.func,
  financePaymentsColumns : PropTypes.array,
  actionButtonText         : PropTypes.string
}

const defaultProps = {
  financePaymentsColumns : [],
  handleClickRow           : () => { }
}

/**
 * Component to display each Payment data in FinancePaymentsUrlParamsTable
 * @param {Object} payment - Payment
 * @param {Function} onClickRow - function to navigate to payment detail page when admin click on data row
 * @param {Array} financePaymentsColumns - Array of displayed finance payments column section
 */
const FinancePaymentsUrlParamsTableRow = ({
  payment,
  onClickRow,
  financePaymentsColumns
}) => {

  const paymentsCellData = FinancePaymentsUrlParamsTableCellService.generatePaymentCellData(payment)

  const handleClickRow = () => {
    onClickRow(payment.id)
  }


  return (
    <tr onClick={ handleClickRow }>
      {
        financePaymentsColumns.map((data) => (
          <td key={ `finance-payment-${payment.id}-${data.name}` } style={ paymentsCellData[data.name].style }>
            { paymentsCellData[data.name].content }
          </td>
        ))
      }
    </tr>
  )

}

FinancePaymentsUrlParamsTableRow.propTypes    = propTypes
FinancePaymentsUrlParamsTableRow.defaultProps = defaultProps

export default FinancePaymentsUrlParamsTableRow